<template>
	<div class="topic_progress">
		<div class="expRevSchedule" style="max-width: 1100px;">
			<div class="progress pro-expertReview">
				<div class="progress-bar progress-bar-striped progress-bar-animated bg-success" :style="scheduleList[status].style"></div>
				<div class="proPoint" :class="{ active: pointActive >= index, ['proPoint' + (index + 1)]: true }" v-for="(item, index) in scheduleList" :key="index">
					<!-- activeIndex: currentNum == item.id -->
					<a v-if="index == 4 && flow == 5">
						<el-popconfirm title="开启专家评分后，评审设置不允许再修改，确定要开启吗？" @confirm="handleScheduleChange(item, index)">
							<a slot="reference">
								<i :class="{ no: pointActive == index && noPassActive == index }">{{ index + 1 }}</i>
								{{ item.name }}
							</a>
						</el-popconfirm>
					</a>

					<a @click="handleScheduleChange(item, index)" v-else>
						<i :class="{ no: pointActive == index && noPassActive == index }">{{ index + 1 }}</i>
						{{ item.name }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	props: {
		status: {
			type: String | Number,
			default: 0
		},
		flow: {
			type: String | Number,
			default: 0
		}
	},
	watch: {
		status(val) {
			this.initProcess();
		}
	},
	data() {
		return {
			pointActive: 0, //点索引
			processActive: 0, //进程索引
			noPassActive: null, //不通过的点
			scheduleList: [
				{ name: '评价基本信息', style: 'width:0%;', id: 0 },
				{ name: '评审分组', style: 'width:14.2%;', id: 1 },
				{ name: '分配专家', style: 'width:28.4%;', id: 3 },
				{ name: '设置评分标准', style: 'width:42.6%;', id: 5 },
				{ name: '开启评审打分', style: 'width:56.8%;', id: 99 },
				{ name: '查看评审进度', style: 'width:71%;', id: 8 },
				{ name: '查看评审结果', style: 'width:86%;', id: 15 },
				{ name: '结束', style: 'width:100%;', id: 17 }
			]
		};
	},
	computed: {
		...mapState(['currentNum'])
	},
	created() {
		this.initProcess();
	},
	methods: {
		// 上传报告
		uploadReport(index) {
			this.$emit('uploadReport', index);
		},
		// 查看意见
		viewOpinion(index) {
			this.$emit('viewOpinion', index);
		},
		initProcess() {
			switch (this.status) {
				case 0:
					this.pointActive = 0;
					this.processActive = 0;
					break;
				case 1:
					this.pointActive = 0;
					this.processActive = 1;
					break;
				case 2:
					this.pointActive = 1;
					this.processActive = 1;
					this.noPassActive = 1;
					break;
				case 3:
					this.pointActive = 1;
					this.processActive = 2;
					break;
				case 4:
					this.pointActive = 2;
					this.processActive = 2;
					this.noPassActive = 2;
					break;
				case 5:
					this.pointActive = 3;
					this.processActive = 3;
					break;
				case 6:
					this.pointActive = 3;
					this.processActive = 4;
					break;
				case 7:
					this.pointActive = 4;
					this.processActive = 4;
					this.noPassActive = 4;
					break;
				case 8:
					this.pointActive = 4;
					this.processActive = 5;
					break;
				case 9:
					this.pointActive = 5;
					this.processActive = 5;
					this.noPassActive = 5;
					break;
				case 15:
					this.pointActive = 6;
					this.processActive = 6;
					break;
				case 16:
					this.pointActive = 6;
					this.processActive = 7;
					break;
				case 17:
					this.pointActive = 7;
					this.processActive = 7;
					// this.noPassActive = 7;
					break;
				case 18:
					this.pointActive = 7;
					this.processActive = 8;
					break;
				case 19:
					this.pointActive = 8;
					this.processActive = 8;
					this.noPassActive = 8;
					break;
				case 20:
				case 21:
				case 22:
				case 23:
				case 24:
				case 25:
				case 26:
				case 27:
				case 28:
				case 29:
				case 30:
				case 31:
				case 32:
					this.pointActive = 8;
					this.processActive = 9;
					break;
				case 33:
					this.pointActive = 9;
					this.processActive = 9;
					this.noPassActive = 9;
					break;
				case 34:
					this.pointActive = 9;
					this.processActive = 9;
					return '已结题';
					break;
				case 35:
					this.pointActive = 9;
					this.processActive = 9;
					this.noPassActive = 9;
					return '拟结题退回修改';
					break;
				default:
					return '未知错误';
			}
		},
		handleScheduleChange(item, index) {
			let object = item;
			object.index = index;
			//结束
			if (this.flow == 17) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
				if (index == 2) {
					this.$store.commit('editNumState', 3);
					this.$emit('changeState', object);
				}
				if (index == 3) {
					this.$store.commit('editNumState', 5);
					this.$emit('changeState', object);
				}
				if (index == 5) {
					this.$store.commit('editNumState', 8);
					this.$emit('changeState', object);
				}
				if (index == 4) {
					this.$store.commit('editNumState', 8);
					this.$emit('changeStateBtn', 8);
				}
				if (index == 6) {
					this.$store.commit('editNumState', 15);
					this.$emit('changeState', object);
				}
				if (index == 7) {
					this.$store.commit('editNumState', 17);
					this.$emit('changeState', object);
				}
			}
			//评审结果
			if (this.flow == 15) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
				if (index == 2) {
					this.$store.commit('editNumState', 3);
					this.$emit('changeState', object);
				}
				if (index == 3) {
					this.$store.commit('editNumState', 5);
					this.$emit('changeState', object);
				}
				if (index == 5) {
					this.$store.commit('editNumState', 8);
					this.$emit('changeState', object);
				}
				if (index == 6) {
					this.$store.commit('editNumState', 15);
					this.$emit('changeState', object);
				}
				if (index == 7) {
					this.$store.commit('editNumState', 17);
					this.$emit('changeState', object);
				}
			}
			//查看评审
			if (this.flow == 8) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
				if (index == 2) {
					this.$store.commit('editNumState', 3);
					this.$emit('changeState', object);
				}
				if (index == 3) {
					this.$store.commit('editNumState', 5);
					this.$emit('changeState', object);
				}
			}

			//设置评分
			if (this.flow == 5) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
				if (index == 2) {
					this.$store.commit('editNumState', 3);
					this.$emit('changeState', object);
				}
				if (index == 3) {
					this.$store.commit('editNumState', 5);
					this.$emit('changeState', object);
				}
			}
			// 分配专家
			if (this.flow == 3) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
				if (index == 2) {
					this.$store.commit('editNumState', 3);
					this.$emit('changeState', object);
				}
			}
			// 评审分组
			if (this.flow == 1) {
				if (index == 0) {
					this.$store.commit('editNumState', 0);
					this.$emit('changeState', object);
				}
				if (index == 1) {
					this.$store.commit('editNumState', 1);
					this.$emit('changeState', object);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
// 隐藏不需要显示的意见
.opinion_item.hidden {
	visibility: hidden;
}
.activeIndex::before {
	background-color: #fff !important;
}
.activeIndex i {
	background-color: #01875f !important;
	color: #fff;
}
.activeIndex::before {
	border: 1px solid #01875f !important;
}

.proPoint.active .no {
	background-color: red;
}

.topic_progress {
	position: relative;
}
.opinion_list,
.report_list {
	position: absolute;
	display: flex;
	align-items: center;
	width: 100%;
	color: #6ac8f1;
	cursor: pointer;
}
.opinion_list {
	top: 5px;
	left: 0;
	.opinion_item {
		width: 10%;
		text-align: center;
	}
}
.report_list {
	bottom: 15px;
	left: 0;
	.report_item {
		background-color: #409eff;
		width: 10%;
		color: #fff;
		text-align: center;
		padding: 2px;
		border-radius: 5px;
	}
	.report_item.hidden {
		visibility: hidden;
	}
}
.pro-expertReview .proPoint1 {
	left: 0;
}
.pro-expertReview .proPoint2 {
	left: 14.2%;
}
.pro-expertReview .proPoint3 {
	left: 28.4%;
}
.pro-expertReview .proPoint4 {
	left: 42.6%;
}
.pro-expertReview .proPoint5 {
	left: 56.8%;
}
.pro-expertReview .proPoint6 {
	left: 71%;
}
.pro-expertReview .proPoint7 {
	left: 86%;
}
.pro-expertReview .proPoint8 {
	left: 100%;
}
</style>
